import { Alert } from '@zorro/design-system/v2/Alert';

export const LynxBankingDisclaimer = () => (
  <Alert variant="general-note" withIcon={false} withCloseButton={false}>
    Zorro is a Health Benefits Administration company, not a bank. Banking
    Services provided by Avidia Bank, Member FDIC, Member DIF. The Zorro
    Mastercard debit card is issued by Avidia Bank pursuant to license by
    Mastercard International.
  </Alert>
);
